import { Box, Button } from '@mui/material';
import React from 'react';
import Loader from 'react-js-loader';
import { colors } from '../../assets/utils/constants';

const CustomSubmitButton = ({
    loading,
    startIcon,
    endIcon,
    onClick,
    btnColor,
    children,
}) => {
    return (
        <>
            <Box>
                <Button
                    variant="contained"
                    onClick={onClick}
                    {...(loading ? '' : '')}
                    disabled={loading ? true : false}
                    startIcon={startIcon}
                    endIcon={endIcon}
                    color={btnColor}
                    className="app-btn"
                    fullWidth
                    sx={{
                        'py': 1.5,
                        'px': 4,
                        'fontWeight': 'bold',
                    }}
                >
                    {children}
                    {loading && (
                        <Box
                            sx={{
                                position: 'absolute',
                                left: 0,
                                right: 0,
                            }}
                        >
                            <Loader
                                type="bubble-loop"
                                bgColor={colors.primary}
                                color={colors.primary}
                                size={50}
                            />
                        </Box>
                    )}
                </Button>
            </Box>
        </>
    );
};

export default CustomSubmitButton;
